import { RoomEvent, RoomEventHandlerMap } from "../../core/room/types";
import { VideoClient } from "../types";
import {
  EVENT_CONFIG_MAP,
  STANDARD_ROOM_EVENT_TO_ZOOM_ROOM_EVENT_MAP,
  StandardRoomEventToZoomRoomEventMap,
} from "./events";

export function isEventSupported(event: string): event is RoomEvent {
  return event in STANDARD_ROOM_EVENT_TO_ZOOM_ROOM_EVENT_MAP;
}

export function getZoomRoomEvent<T extends RoomEvent>(
  standardEvent: T,
): StandardRoomEventToZoomRoomEventMap[T] | undefined {
  return STANDARD_ROOM_EVENT_TO_ZOOM_ROOM_EVENT_MAP[standardEvent];
}

export function createZoomRoomEventHandler<K extends RoomEvent>(
  videoClient: VideoClient,
  event: K,
  handler: RoomEventHandlerMap[K],
) {
  const createHandler = EVENT_CONFIG_MAP[event];

  if (!createHandler) {
    throw new Error(`Unsupported Zoom Room event: ${event}`);
  }

  return createHandler(videoClient, handler);
}
